var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg19(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.164,
    height: 70.196,
    viewBox: "0 0 74.164 70.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_10_59",
    "data-name": "Komponente 10 \\u2013 59",
    transform: "translate(0.164 0.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "healthy-food",
    d: "M58.793,47.771l-.7-.16c6.748-5.528,8.186-17.8,1.83-24.2A14.968,14.968,0,0,1,56.02,13c0-5.888-3.873-10.679-8.635-10.679S38.75,7.109,38.75,13a16.818,16.818,0,0,1-.459,3.911A12.261,12.261,0,0,0,22.1,14.474V2.464a.943.943,0,1,0-1.885,0v3.7C17.4,1.086,12.275-.273,6.536.882A.945.945,0,0,0,5.85,2.164a22.106,22.106,0,0,0,3.776,5.87c2.9,3.172,6.508,4.748,10.588,3.618v2.822C14.677,10.626,5.405,12.007,1.6,20.781a.943.943,0,0,0,1.73.75c3.486-8.027,11.821-8.676,16.242-5.194a2.469,2.469,0,0,0,3.178,0c5.033-3.964,13.739-2.239,16.723,6.435a17.4,17.4,0,0,1-1.5,14.61c-1.107,1.981-2.018,3.628-2.77,5-5.839-1.258-6.672-1.718-8.66-1.675a.942.942,0,1,0,.039,1.884,8.042,8.042,0,0,1,1.14.061l-.565,5.078a.943.943,0,0,0,1.874.208l.547-4.909,9.138,2.088-.27,2.421a.943.943,0,1,0,1.874.208l.246-2.208,14.132,3.229L53.965,55.3a.943.943,0,0,0,1.874.209l.7-6.323,1.83.418a4.548,4.548,0,0,1-1,8.982l-9.65.019.343-3.074a.943.943,0,1,0-1.874-.209l-.366,3.287-9.249.018.322-2.89a.943.943,0,0,0-1.874-.208c-.08.72-.337,3.026-.345,3.1l-4.428.008.561-5.031a.943.943,0,0,0-1.874-.208l-.584,5.243h-.034l-1.562,0a8.028,8.028,0,0,1-3.433-15.287.943.943,0,1,0-.809-1.7,9.89,9.89,0,0,0-4.308,3.929,11.732,11.732,0,0,1-5.255-4.653,3.111,3.111,0,0,0-5.858,1.442L4.138,37.007a17.354,17.354,0,0,1-1.885-12.07.943.943,0,1,0-1.847-.382A19.243,19.243,0,0,0,2.485,37.916l4.028,7.321-2.952-.329a3.11,3.11,0,0,0-.689,6.181l4.887.544C6.548,52.718,5.572,53.7,5.695,55.252a3.114,3.114,0,0,0,5.463,1.779,11.744,11.744,0,0,1,6.151-3.387,9.928,9.928,0,0,0,9.446,6.892l30.618-.059a6.433,6.433,0,0,0,1.42-12.705ZM8.11,2.527c6.269-.856,10.222,2.132,11.543,7.324C14.545,11.226,10.529,7.188,8.11,2.527ZM55.638,47.05l-18.52-4.231c.535-.98,1.129-2.063,1.79-3.253a10.074,10.074,0,0,0,18.6-3.054.943.943,0,0,0-1.849-.37,8.189,8.189,0,0,1-15.635,1.416A19.479,19.479,0,0,0,42.314,28.3a8.2,8.2,0,0,1,13.318,4.482.943.943,0,1,0,1.843-.4,10.072,10.072,0,0,0-15.31-6.318,18.555,18.555,0,0,0-2.454-7.212A18.641,18.641,0,0,0,40.636,13c0-4.35,2.709-8.793,6.749-8.793,4,0,6.749,4.383,6.749,8.793a16.658,16.658,0,0,0,4.455,11.745c4.91,4.938,4.435,14.1.17,19.5a11.734,11.734,0,0,1-3.122,2.8Zm-38.73,4.738a13.69,13.69,0,0,0-7.183,4.018,1.224,1.224,0,1,1-1.86-1.59,13.041,13.041,0,0,1,2.851-2.466.943.943,0,0,0-.407-1.728l-7.227-.806a1.224,1.224,0,1,1,.271-2.432h.006l.022,0h0l.022,0-.014,0,6.531.728c.3-.019,1.213.369,1.613-.45a.943.943,0,0,0-.175-1.073,13.048,13.048,0,0,1-2.237-3.032,1.226,1.226,0,0,1,.51-1.654h0a1.223,1.223,0,0,1,1.653.512,13.651,13.651,0,0,0,6.129,5.473,10.026,10.026,0,0,0-.505,4.5Zm0,0",
    transform: "translate(-0.001 -0.498)",
    fill: "#a5b5af",
    stroke: "#a5b5af",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35494",
    "data-name": "Gruppe 35494",
    transform: "translate(-320 -2890.983)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_555",
    "data-name": "Ellipse 555",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(364 2931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    transform: "translate(367 2934)",
    fill: "#fff",
    stroke: "#a5b5af",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46717",
    "data-name": "Pfad 46717",
    d: "M23.5,6l-7.692,7.7L13.5,11.392",
    transform: "translate(360.5 2936.15)",
    fill: "none",
    stroke: "#a5b5af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg19);
export default __webpack_public_path__ + "static/media/19.e9ba7b3f919a2efc5b3c99465a2d4b13.svg";
export { ForwardRef as ReactComponent };